import { render, staticRenderFns } from "./BurgerImage.vue?vue&type=template&id=651a1ffa&scoped=true&"
import script from "./BurgerImage.vue?vue&type=script&lang=js&"
export * from "./BurgerImage.vue?vue&type=script&lang=js&"
import style0 from "./BurgerImage.vue?vue&type=style&index=0&id=651a1ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651a1ffa",
  null
  
)

export default component.exports